export const useHomePage = () => {
  const route = useRoute()

  const isHomePage = computed(() => {
    return route.name ? ['nl-index', 'en-index', 'de-index'].includes(route.name as string) : false
  })

  return { isHomePage }
}
